import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const Subtitle = styled.span`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.secondary};
  margin-left: ${space['space-200']};
`;

export const TitleAlignmentWrapper = styled.div<{ $align: 'left' | 'center' }>`
  width: 100%;
  grid-column: 1 / -1;
  text-align: ${({ $align }) => $align};
`;
